/* =====================================================
   FAQ — переключение ответов
===================================================== */
document.addEventListener('DOMContentLoaded', () => {
  const questions = document.querySelectorAll('.faq__question');
  const answers = document.querySelectorAll('.faq__answer');
  if (!questions.length || !answers.length) return;

  questions.forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.faq;

      // Активный вопрос
      questions.forEach((q) => q.classList.remove('is-active'));
      btn.classList.add('is-active');

      // Активный ответ
      answers.forEach((a) => {
        a.classList.toggle('is-active', a.dataset.faqAnswer === id);
      });
    });
  });
});
